export const NOVIDADES_STORAGE_KEY = 'gpshub:novidades:v2.2.0:read';
export const NOVIDADES_VERSION = '2.2.0';
export const NOVIDADES_RELEASE_DATE = '23/10/2026';
export const NOVIDADES_STATUS = 'Lançado';

/* `soMaster` - conteudo que NAO aparece para quem nao e Master.

   Nao e so esconder um item de menu: a documentacao contava a existencia de um
   nivel de acesso acima, com frases como "exclusivo da versao desenvolvedor".
   Quem le isso e nao tem o perfil aprende duas coisas que nao deveria - que
   existe um nivel privilegiado e quais ferramentas ele tem. Manual serve para
   ensinar a usar o que se pode usar; o resto e superficie de ataque e
   frustracao ("por que eu nao tenho isso?").

   A marca fica no DADO e nao na tela, porque as duas telas (Manual e
   Novidades) leem a mesma lista e precisam esconder o mesmo conjunto. */
export type NovidadeItem = {
  id: string;
  /** So aparece para Master. */
  soMaster?: boolean;
  title: string;
  date: string;
  version: string;
  status: string;
  description: string;
  details?: string[];
};

export type ManualItem = {
  id: string;
  title: string;
  description: string;
  steps: string[];
};

export type ManualScreenItem = {
  id: string;
  /** So aparece para Master. */
  soMaster?: boolean;
  title: string;
  path: string;
  icon: string;
  emoji?: string;
  accent: string;
  description: string;
  purpose: string;
  usage: string;
  highlights: string[];
  featureChips?: string[];
  actionGroups?: {
    title: string;
    icon: string;
    items: string[];
  }[];
  visualGuide?: {
    title: string;
    description: string;
    steps: string[];
  };
  preview: {
    badge: string;
    title: string;
    subtitle: string;
    metrics: string[];
    columns: string[];
  };
};

export const novidadesItems: NovidadeItem[] = [
  {
    id: 'assistente-consulta',
    title: 'Assistente: pergunte em vez de procurar',
    date: '23/10/2026',
    version: '2.2.0',
    status: 'Novo recurso',
    description: 'Um robô flutuante no canto da tela responde perguntas sobre o parque. Ele só consulta: não altera nada.',
    details: [
      'Responde sobre aparelhos, grupos, políticas, regionais, aplicativos, tickets e "como fazer".',
      'Exemplos: "resumo do parque", "aparelhos online", "aparelhos pendentes", "quem tem o WhatsApp instalado?", "aparelhos sem contato há 7 dias", "tickets por mês".',
      'Mostra gráficos de rosca e de linha quando a resposta é uma distribuição ou uma evolução.',
      'Digitar só o nome de um grupo, aparelho ou regional já abre a ficha dele (busca livre).',
      'O botão "?" mostra o que perguntar, agrupado por assunto. A tecla Esc fecha o assistente.',
      'Respeita as regionais de cada usuário. Usuário comum vê só grupos, resumo, tickets e manual.',
    ],
  },
  {
    id: 'tela-monitoramento',
    soMaster: true,
    title: 'Tela Monitoramento',
    date: '23/10/2026',
    version: '2.2.0',
    status: 'Novo recurso',
    description: 'Acompanhe a saúde do servidor e do banco de dados sem sair do GPShub.',
    details: [
      'Aba Servidor: CPU, memória, disco, memória da API e processos do pm2.',
      'Aba Banco de dados: arquivos, maiores tabelas e conexões.',
    ],
  },
  {
    id: 'listas-pesquisa-selecao',
    title: 'Listas: pesquisa por Enter e seleção em janela',
    date: '23/10/2026',
    version: '2.2.0',
    status: 'Melhoria',
    description: 'A pesquisa das listas só roda ao apertar Enter ou clicar na lupa, e os campos de seleção abrem uma janela para escolher.',
    details: [
      'Digitar não dispara mais uma consulta a cada letra.',
      'A janela de seleção é paginada: funciona mesmo com milhares de opções.',
    ],
  },
  {
    id: 'tickets-por-regional',
    title: 'Tickets por regional',
    date: '23/10/2026',
    version: '2.2.0',
    status: 'Melhoria',
    description: 'Cada um vê e responde os tickets das suas regionais. Só o Master encerra.',
    details: [
      'Clicar na notificação de um ticket abre o ticket.',
      'O cartão Resolvidos agora fica na mesma linha dos outros quatro.',
      'O botão de mensagem flutuante aparece só na tela de Tickets.',
    ],
  },
  {
    id: 'retencao-noturna',
    title: 'Limpeza noturna de dados antigos',
    date: '23/10/2026',
    version: '2.2.0',
    status: 'Melhoria',
    description: 'Uma rotina automática à noite mantém o banco enxuto.',
    details: [
      'Logs dos aparelhos e consumo de dados ficam guardados por 6 meses.',
      'O histórico fica guardado por 5 anos.',
      'O último estado de cada aparelho nunca é apagado.',
    ],
  },
  {
    id: 'politica-redes-wifi',
    title: 'Redes Wi-Fi entregues pela política',
    date: '30/09/2026',
    version: '2.1.0',
    status: 'Novo recurso',
    description: 'A política agora pode enviar redes Wi-Fi já configuradas: o aparelho recebe a rede com a senha, sem ninguém digitar nada.',
    details: [
      'Novo passo "Redes Wi-Fi" na edição da política, com até 10 redes (WPA/WPA2, WEP ou aberta).',
      'As redes SOMAM às que o aparelho já tem: nenhuma rede cadastrada pelo usuário é apagada ou bloqueada.',
      'No aparelho, a rede aparece em Redes salvas como "Salva por Device Policy".',
      'Tirar uma rede da lista remove só ela dos aparelhos. A senha fica guardada e não aparece de volta na tela.',
    ],
  },
  {
    id: 'apk-no-grupo-libera',
    title: 'APK adicionado ao grupo já fica liberado no aparelho',
    date: '30/09/2026',
    version: '2.1.0',
    status: 'Correção',
    description: 'Ao adicionar um APK a um grupo, o aplicativo é criado no catálogo (se ainda não existir) e entra na política como disponível para instalar.',
    details: [
      'Antes o pacote ficava só no GPShub e o aparelho continuava bloqueando a instalação.',
      'Se o Google recusar a política, o erro aparece na tela ao salvar o grupo.',
    ],
  },
  {
    id: 'grupo-uma-politica',
    title: 'Um grupo, uma política',
    date: '30/09/2026',
    version: '2.1.0',
    status: 'Melhoria',
    description: 'Cada grupo tem uma única política. Se um grupo tiver mais de uma, vale sempre a última criada.',
    details: [
      'Duplicar uma política cria a cópia sem grupo: escolha um grupo que ainda não tenha política.',
      'Todo grupo passa a exigir uma regional ao ser criado ou editado.',
    ],
  },
  {
    id: 'novo-aplicativo-grupos',
    title: 'Novo aplicativo já vinculado aos grupos escolhidos',
    date: '30/09/2026',
    version: '2.1.0',
    status: 'Correção',
    description: 'Os grupos marcados ao cadastrar um aplicativo agora recebem o app de verdade, e o status escolhido é respeitado.',
    details: [
      'Adicionar, remover ou limpar dados de app em grupos: até 10 grupos por vez.',
      'A checagem de "pacote já cadastrado" compara o nome exato do pacote.',
    ],
  },
  {
    id: 'comandos-perda-roubo',
    title: 'Modo perdido e comandos mais claros',
    date: '30/09/2026',
    version: '2.1.0',
    status: 'Melhoria',
    description: 'O modo perdido exige ao menos mensagem, telefone ou e-mail, para quem achar o aparelho saber a quem devolver.',
    details: [
      'A ficha do aparelho avisa quando ele está em modo perdido com a tela de bloqueio sem mensagem.',
      'Senha, perda e roubo, limpar dados e mudar grupo dizem "comando enviado": o aparelho aplica quando estiver online.',
      '"Trocar senha" já abre com "Bloquear ao trocar" marcado.',
    ],
  },
  {
    id: 'politica-sem-som',
    title: 'Opção "Sem som" na política',
    date: '30/09/2026',
    version: '2.1.0',
    status: 'Melhoria',
    description: 'A opção que antes se chamava "Ajuste de volume" agora se chama "Sem som (bloqueia o volume)": ela silencia o aparelho e impede mudar o volume.',
  },
  {
    id: 'tickets-sla',
    title: 'Tickets com SLA por categoria',
    date: '29/09/2026',
    version: '2.1.0',
    status: 'Novo recurso',
    description: 'O suporte agora funciona por tickets: cada categoria define a prioridade e o prazo de atendimento em dias úteis.',
    details: [
      'A prioridade vem da categoria escolhida — quem abre não precisa escolher.',
      'Cartões de Abertos, Em atendimento, Respondidos, SLA vencido e Resolvidos.',
      'Cada ticket tem histórico completo: abertura, respostas, mudanças de status e de prazo.',
    ],
  },
  {
    id: 'correcoes-set-2026',
    title: 'Correções e segurança',
    date: '30/09/2026',
    version: '2.1.0',
    status: 'Correção',
    description: 'Revisão geral do sistema, com dezenas de correções de telas e de permissões.',
    details: [
      'Cada usuário só vê e altera o que é das suas regionais, também nos comandos de aparelho.',
      'Busca → "Registrar IMEIs" volta a funcionar e diz quantos já existiam e quantos foram para a fila.',
      'Categorias e feriados pedem confirmação antes de apagar.',
      'O card de consumo de dados da Home diz se o número é do parque inteiro ou da regional.',
      'Listas não perdem mais a página nem mostram total antigo depois de um erro.',
    ],
  },
  {
    id: 'mensagens-notificacoes',
    title: 'Mensagens e central de notificações',
    date: '27/05/2026',
    version: '1.5.0',
    status: 'Novo recurso',
    description: 'Agora dá para enviar mensagens ao suporte e acompanhar notificações direto pelo sino no topo.',
    details: [
      'Sino de notificações no cabeçalho com contador de não lidas e marcação de lida.',
      'Tela de Mensagens e botão flutuante para enviar mensagem (tipo, descrição, texto e anexo).',
      'A mensagem chega ao suporte e, se marcar uma regional, também aos usuários dela.',
      'Solicitações de acesso a regionais também aparecem como notificação.',
    ],
  },
  {
    id: 'dispositivos-configurar',
    soMaster: true,
    title: 'Dispositivos: Listar, Buscar e Configurar',
    date: '27/05/2026',
    version: '1.5.0',
    status: 'Novo recurso',
    description: 'O menu Dispositivos foi reorganizado e ganhou uma área de configuração rápida.',
    details: [
      'Submenu Dispositivos: Listar, Buscar e Configurar.',
      'Configurar: Vincular dispositivo (por Device ID, IMEI ou Serial), Registrar IMEIs em lote e Limpar cache.',
      'Ações com limite de 1 minuto por usuário para evitar repetição acidental.',
    ],
  },
  {
    id: 'aplicativos-detalhes-modal',
    title: 'Detalhes rápidos na lista de Aplicativos',
    date: '27/05/2026',
    version: '1.5.0',
    status: 'Melhoria',
    description: 'Na lista de aplicativos, clique nos números de Grupos ou Dispositivos para ver os detalhes.',
    details: [
      'Clicar em Grupos abre um grid com os grupos do app.',
      'Clicar em Dispositivos abre um grid com os dispositivos que têm o app.',
      'Campo de pesquisa dentro do modal e remoção de grupo direto na linha (coluna Opções).',
    ],
  },
  {
    id: 'dispositivo-outros-detalhes',
    title: 'Aba "Outros detalhes" no dispositivo',
    date: '27/05/2026',
    version: '1.5.0',
    status: 'Melhoria',
    description: 'A tela de detalhes do dispositivo ganhou uma aba com todas as informações organizadas.',
    details: [
      'Seções de Identificação, Hardware, Software, Rede e Uso/Localização.',
      'Histórico de alterações também disponível em Regionais (edição e acessos).',
      'Diversas correções de contraste no modo escuro (menu, tabelas, formulários e campos).',
    ],
  },
  {
    id: 'home-filtro-regional',
    title: 'Filtro por regional na Home',
    date: '27/05/2026',
    version: '1.4.0',
    status: 'Novo recurso',
    description: 'Agora é possível filtrar os indicadores da Home por regional, vendo os números de uma regional específica em vez de todas as suas regionais somadas.',
    details: [
      'Seletor de regional no topo da Home, para quem atende mais de uma.',
      'Dispositivos, grupos, usuários e os indicadores do dia passam a refletir a regional selecionada.',
      'Resultado fica em cache por regional, deixando a resposta instantânea ao revisitar.',
      'Limpe o filtro (opção "Todas") para voltar à visão geral consolidada.',
    ],
  },
  {
    id: 'regionais-solicitacao-acesso',
    title: 'Solicitação de acesso a regionais',
    date: '27/05/2026',
    version: '1.4.0',
    status: 'Novo recurso',
    description: 'A listagem de regionais passa a mostrar todas as regionais liberadas; você edita apenas as que tem acesso e pode pedir acesso às demais.',
    details: [
      'Regionais marcadas como visíveis aparecem para todos, mas só são editáveis por quem tem acesso.',
      'Botão "Pedir acesso" cria uma solicitação que fica pendente para aprovação.',
      'Solicitações expiram em 5 dias caso não sejam aprovadas — depois é possível solicitar novamente.',
      'Notificação no topo avisa os responsáveis sobre solicitações pendentes.',
    ],
  },
  {
    id: 'dark-mode-fixes',
    title: 'Correções no modo escuro',
    date: '27/05/2026',
    version: '1.4.0',
    status: 'Melhoria',
    description: 'Vários componentes que apareciam com fundo branco ou texto de baixo contraste no modo escuro foram corrigidos.',
    details: [
      'Formulários de cadastro (aplicativos, usuários, APKs, regionais, entidades) e modais agora respeitam o tema escuro.',
      'O cabeçalho das tabelas/listagens deixou de aparecer branco no modo escuro.',
      'Texto do menu lateral ficou mais legível no modo escuro.',
    ],
  },
  {
    id: 'login-redesign',
    title: 'Tela de login redesenhada e mais moderna',
    date: '16/04/2026',
    version: '1.3.0',
    status: 'Melhoria',
    description: 'A página de login foi completamente redesenhada com um visual premium e moderno, seguindo o padrão de plataformas enterprise de alto nível.',
    details: [
      'Painel esquerdo: card branco flutuante com logo, inputs modernos com ícones e sombras suaves.',
      'Painel direito: tema espacial em navy escuro com foguete 3D, arcos orbitais animados, planetas e cards de benefícios.',
      'Design inspirado em plataformas como Microsoft Intune, JumpCloud e Kandji — visual limpo e profissional.',
      'Totalmente responsivo, adaptando-se a diferentes tamanhos de tela com layout otimizado.',
    ],
  },
  {
    id: 'cross-profile',
    title: 'Controle de cópia/cola e compartilhamento entre perfis',
    date: '16/04/2026',
    version: '1.3.0',
    status: 'Novo recurso',
    description: 'A política agora permite controlar se o usuário pode copiar e colar texto entre o perfil pessoal e o de trabalho, e se dados podem ser compartilhados entre os perfis via intents.',
    details: [
      'Campo "Copia/Cola Texto": define se texto copiado no perfil de trabalho pode ser colado no perfil pessoal e vice-versa.',
      'Campo "Compartilhar Documentos": controla o compartilhamento de dados entre perfis, incluindo ações como abrir navegador, mapa, compartilhar conteúdo e abrir documentos.',
      'Ambos os campos estão disponíveis na tela de edição de política e salvos no banco de dados.',
      'O padrão de ambos os campos é "Permitido entre perfis", podendo ser restrito conforme a necessidade da operação.',
    ],
  },
  {
    id: 'release-130',
    title: 'Versão 1.3.0 lançada',
    date: '16/04/2026',
    version: '1.3.0',
    status: 'Lançado',
    description: 'Atualização da plataforma com redesign da tela de login, novos controles de política de perfil cruzado e expansão do manual de uso.',
    details: [
      'Tela de login completamente redesenhada com visual premium e tema espacial no painel direito.',
      'Novos campos de controle entre perfis pessoal e de trabalho adicionados à política.',
      'Manual atualizado com documentação completa de políticas: aplicativos, bloqueios e sites.',
      'Versão bumped de 1.2.0 para 1.3.0 com ajuste do indicador de novidades no menu lateral.',
    ],
  },
  {
    id: 'release',
    title: 'Novidades da versão 1.2.0',
    date: '09/04/2026',
    version: '1.2.0',
    status: 'Lançado',
    description: 'A tela de Novidades foi reorganizada com melhor leitura, textos revisados e uma experiência visual mais moderna.',
    details: [
      'Agora o menu lateral exibe um indicador quando existem novidades ainda não visualizadas.',
      'Ao abrir a página, a leitura é registrada no localStorage para não manter o alerta após a visualização.',
    ],
  },
  {
    id: 'home-dashboard',
    title: 'Home com novas estatísticas do dia',
    date: '09/04/2026',
    version: '1.2.0',
    status: 'Atualizado',
    description: 'A tela inicial passou a exibir indicadores diários para dar mais visibilidade à operação logo no primeiro acesso.',
    details: [
      'Agora a Home mostra quantidade de logins do dia, dispositivos cadastrados hoje, logs gerados hoje e históricos gravados hoje.',
      'Também foram adicionados indicadores de dispositivos roubados hoje e dispositivos inativados hoje.',
    ],
  },
  {
    id: 'transferencia-automatica',
    title: 'Transferência automática de grupo',
    date: '20/03/2026',
    version: '1.0.0',
    status: 'Lançado',
    description: 'A transferência de grupo foi automatizada para agilizar a operação entre regionais e reduzir etapas manuais.',
    details: [
      'Permite transferir dispositivos a partir de qualquer regional com mais praticidade.',
      'O fluxo ficou mais rápido para equipes que movimentam dispositivos entre grupos com frequência.',
    ],
  },
  {
    id: 'qrcode',
    title: 'Leitura de QR Code pela web e pelo dispositivo',
    date: '02/04/2026',
    version: '1.2.0',
    status: 'Novo recurso',
    description: 'O QR Code pode ser utilizado tanto na web quanto no próprio dispositivo para facilitar a identificação e o vínculo dos equipamentos.',
    details: [
      'A leitura pela web simplifica o atendimento operacional em desktop.',
      'A leitura no dispositivo acelera processos em campo e reduz erros de digitação.',
    ],
  },
  {
    id: 'buscar',
    title: 'Busca avançada de dispositivos',
    date: '27/03/2026',
    version: '1.1.0',
    status: 'Lançado',
    description: 'A busca agora permite localizar dispositivos por Device ID, nome ou IMEI com mais clareza e acesso rápido às informações principais.',
    details: [
      'A consulta exibe Device ID, nome, regional, grupo, política e o mapa com o último log.',
      'Também houve ajuste no salvamento de aplicativos básicos para deixar o fluxo mais confiável.',
    ],
  },
  {
    id: 'mdm-google',
    title: 'MDM com controle de dispositivos pelo Google',
    date: '05/04/2026',
    version: '1.2.0',
    status: 'Destaque',
    description: 'O sistema consolida recursos de MDM para gerenciamento de dispositivos com apoio do ecossistema Google.',
    details: [
      'A proposta é centralizar o controle operacional, a leitura dos dispositivos e as ações administrativas em um único ambiente.',
      'Isso melhora a visibilidade do parque de dispositivos e ajuda no acompanhamento do ciclo de gestão.',
    ],
  },
];

export const manualItems: ManualItem[] = [
  {
    id: 'manual-assistente',
    title: 'Como perguntar ao assistente sobre um aparelho',
    description: 'O assistente é o robô no canto da tela. Ele só consulta: nada do que você perguntar altera aparelhos, grupos ou políticas.',
    steps: [
      'Clique no robô flutuante no canto da tela para abrir o assistente.',
      'Digite a pergunta, por exemplo "onde está o aparelho X" ou "aparelhos sem contato há 7 dias". Para ver a ficha de um aparelho, grupo ou regional, basta digitar o nome.',
      'Clique no "?" para ver o que dá para perguntar, agrupado por assunto.',
      'Quando a resposta for uma distribuição ou evolução, ela vem com gráfico (rosca ou linha).',
      'Pressione Esc para fechar.',
    ],
  },
  {
    id: 'manual-monitoramento',
    title: 'Como acompanhar o servidor e o banco',
    description: 'A tela Monitoramento mostra se o servidor e o banco de dados estão saudáveis.',
    steps: [
      'Abra Monitoramento no menu lateral.',
      'Na aba Servidor, veja CPU, memória, disco, memória da API e os processos do pm2.',
      'Na aba Banco de dados, veja os arquivos, as maiores tabelas e as conexões abertas.',
    ],
  },
  {
    id: 'manual-wifi',
    title: 'Como enviar uma rede Wi-Fi para os aparelhos',
    description: 'A política entrega a rede já configurada. Ela soma às redes do aparelho, sem apagar nenhuma.',
    steps: [
      'Abra a política do grupo e vá ao passo "Redes Wi-Fi".',
      'Clique em "+ Adicionar rede" e informe o nome da rede (SSID) exatamente como aparece no roteador.',
      'Escolha a segurança (normalmente WPA/WPA2) e digite a senha. Marque "Oculta" se a rede não aparece na lista do celular.',
      'Salve a política. Na próxima sincronização a rede aparece no aparelho em Configurações → Wi-Fi → Redes salvas, como "Salva por Device Policy".',
      'Para trocar a senha depois, digite a nova; deixar o campo vazio mantém a senha atual.',
    ],
  },
  {
    id: 'manual-perda-roubo',
    title: 'Como colocar um aparelho em modo perdido',
    description: 'Trava o aparelho e mostra uma mensagem na tela para quem o encontrar.',
    steps: [
      'Abra o aparelho (Dispositivos → aparelho) e, em "Mais ações", escolha Perda e roubo.',
      'Preencha ao menos um campo: mensagem, telefone ou e-mail. Sem isso o sistema não envia.',
      'Confirme. O aparelho entra em modo perdido quando estiver online.',
      'Para liberar, abra Perda e roubo de novo e escolha destravar.',
    ],
  },
  {
    id: 'manual-apk-grupo',
    title: 'Como liberar um APK para um grupo',
    description: 'O APK adicionado ao grupo fica disponível para instalar nos aparelhos dele.',
    steps: [
      'Cadastre o APK em APKS, se ainda não estiver lá.',
      'Abra o grupo e, na parte de APKs, adicione o APK desejado.',
      'Salve o grupo. O aplicativo é criado no catálogo, se precisar, e entra na política como disponível.',
    ],
  },
  {
    id: 'manual-ticket',
    title: 'Como abrir um ticket para o suporte',
    description: 'O ticket registra o pedido e acompanha o prazo de atendimento.',
    steps: [
      'Vá a Tickets e clique em "+ Abrir ticket".',
      'Escolha a categoria — ela define a prioridade e o prazo — e descreva o problema.',
      'Acompanhe as respostas no próprio ticket. O cartão "Respondidos" mostra os que aguardam você.',
    ],
  },
  {
    id: 'manual-novidades',
    title: 'Como acompanhar novas versões',
    description: 'A aba de Novidades mostra os recursos liberados, melhorias visuais e ajustes importantes de cada versão.',
    steps: [
      'Abra a página de Novidades pelo menu lateral para registrar a leitura da versão atual.',
      'Verifique a data, a versão e o status de cada item para entender o que foi lançado.',
      'Use esse histórico para orientar sua equipe sobre mudanças recentes no sistema.',
    ],
  },
  {
    id: 'manual-politica-apps',
    title: 'Como adicionar aplicativos à política',
    description: 'A política permite definir quais aplicativos serão instalados, bloqueados ou permitidos nos dispositivos do grupo.',
    steps: [
      'Abra a política desejada e acesse a aba ou seção de Aplicativos.',
      'Busque o aplicativo pelo nome ou package name e selecione-o para vincular à política.',
      'Defina o tipo de instalação: FORCE_INSTALLED (instalação obrigatória), BLOCKED (bloqueado) ou AVAILABLE (disponível para o usuário instalar).',
      'Salve a política para que a configuração seja enviada automaticamente aos dispositivos do grupo.',
    ],
  },
  {
    id: 'manual-politica-bloqueios',
    title: 'Como configurar bloqueios na política',
    description: 'Os bloqueios controlam o que o usuário pode ou não fazer no dispositivo, como tirar screenshot, usar USB, alterar configurações ou copiar dados entre perfis.',
    steps: [
      'Abra a edição da política e localize a seção de bloqueios e restrições.',
      'Ative ou desative os toggles de acordo com o nível de restrição necessário para o grupo.',
      'Para controle de perfil cruzado, use os campos "Copia/Cola Texto" e "Compartilhar Documentos" para definir se dados podem transitar entre o perfil pessoal e de trabalho.',
      'Campos como Bluetooth, Wi-Fi, câmera, USB e modo avião também podem ser configurados individualmente.',
      'Após configurar, salve a política para aplicar as restrições a todos os dispositivos vinculados.',
    ],
  },
  {
    id: 'manual-politica-sites',
    title: 'Como bloquear ou liberar sites na política',
    description: 'A política permite criar listas de sites bloqueados ou liberados para os dispositivos do grupo, controlando o acesso à web.',
    steps: [
      'Abra a edição da política e localize a seção de Bloqueio de Sites.',
      'Adicione os domínios que devem ser bloqueados (ex: facebook.com, youtube.com) ou liberados conforme a necessidade.',
      'Defina se a regra é de bloqueio (o site será impedido) ou liberação (o site será permitido mesmo em ambientes mais restritivos).',
      'Salve a política para que as regras sejam aplicadas ao navegador dos dispositivos do grupo.',
    ],
  },
  {
    id: 'manual-atualizado',
    title: 'Manual atualizado',
    description: 'O manual agora foi separado em uma área própria do menu e passou a concentrar explicações mais completas sobre cada tela do sistema.',
    steps: [
      'Acesse o item Manual no menu lateral para consultar as telas documentadas.',
      'Veja em cada card o que a tela faz, quando usar e os principais destaques do módulo.',
      'Use o manual como referência rápida para treinamento, operação e apoio ao atendimento.',
    ],
  },
  {
    id: 'manual-qrcode',
    title: 'Como usar o QR Code',
    description: 'O QR Code foi pensado para simplificar a identificação de dispositivos tanto no atendimento via web quanto no uso direto pelo aparelho.',
    steps: [
      'Na web, utilize a leitura para localizar ou associar rapidamente o dispositivo correto.',
      'No dispositivo, a leitura ajuda a acelerar processos operacionais em campo.',
      'Sempre confirme se o equipamento exibido corresponde ao grupo e à política esperados.',
    ],
  },
  {
    id: 'manual-mdm',
    title: 'Visão geral do MDM',
    description: 'O sistema de MDM concentra informações e controles que apoiam a gestão de dispositivos ao longo da operação.',
    steps: [
      'Monitore grupos, políticas e dados principais do dispositivo em um só lugar.',
      'Utilize a busca e o histórico recente para localizar rapidamente o contexto de cada equipamento.',
      'Apoie a administração do ambiente com os recursos integrados ao ecossistema Google.',
    ],
  },
];

export const manualScreens: ManualScreenItem[] = [
  {
    id: 'home',
    title: 'Home',
    path: '/dashboard/app',
    icon: 'solar:home-2-bold-duotone',
    emoji: '🏠',
    accent: '#1d4ed8',
    description: 'Tela inicial do sistema com cartões de resumo para grupos, usuários, dispositivos, aplicativos e políticas.',
    purpose: 'Serve como ponto de entrada da operação, ajudando o usuário a entender rapidamente o volume de itens cadastrados e a navegar com mais velocidade para os módulos principais.',
    usage: 'Use essa tela no início do atendimento ou da rotina diária para ter uma leitura geral do ambiente e abrir rapidamente a área que precisa de análise ou manutenção.',
    highlights: ['Resumo operacional', 'Acesso rápido pelos cards', 'Visão geral do ambiente'],
    featureChips: ['KPIs do dia', 'Escopo regional', 'Leitura rápida'],
    preview: {
      badge: 'Dashboard',
      title: 'Indicadores principais',
      subtitle: 'Exibe contadores e atalhos para as áreas mais usadas da plataforma.',
      metrics: ['Políticas', 'Grupos', 'Usuários', 'Dispositivos'],
      columns: ['Cards de resumo', 'Atalhos do sistema', 'Leitura rápida do ambiente'],
    },
  },
  {
    id: 'aplicativos',
    title: 'Aplicativos',
    path: '/dashboard/aplicativos',
    icon: 'solar:widget-5-bold-duotone',
    emoji: '📦',
    accent: '#0f766e',
    description: 'Gerencia os aplicativos cadastrados com busca por nome ou package, status, grupos vinculados e modelos de instalação usados na operação.',
    purpose: 'Centraliza o catálogo de aplicativos utilizados no ambiente, facilitando a conferência de package name, origem de instalação, status, distribuição e relacionamentos com grupos e dispositivos.',
    usage: 'É a tela indicada quando você precisa localizar um aplicativo específico, revisar onde ele está vinculado, confirmar a forma de instalação ou abrir as opções de edição e manutenção.',
    highlights: ['Package name', 'Status do app', 'Grupos e dispositivos'],
    featureChips: ['Instalação via package', 'URL da Play Store', 'Distribuição controlada'],
    actionGroups: [
      {
        title: 'Como cadastrar instalação',
        icon: 'solar:download-minimalistic-bold-duotone',
        items: [
          'Você pode cadastrar o app pelo package name quando a instalação será buscada direto na Play Store.',
          'Use a URL da Play Store para deixar claro qual aplicativo deve ser instalado em campo.',
          'Também é possível relacionar o aplicativo com grupos e políticas para automatizar a entrega.',
        ],
      },
      {
        title: 'Tipos de instalação',
        icon: 'solar:widget-add-bold-duotone',
        items: [
          'Instalação por package com URL da Play é ideal para apps públicos da loja.',
          'Instalação por APK atende cenários internos, homologação ou distribuição fora da loja.',
          'Em políticas mais restritivas, revise se o app está permitido antes de publicar para os dispositivos.',
        ],
      },
    ],
    visualGuide: {
      title: 'Dicas',
      description: 'Imagine um painel moderno exibindo o card do aplicativo, o package name e um botão destacando a instalação pela Play Store.',
      steps: [
        '1. Localize o app pelo nome ou package.',
        '2. Confira a URL da Play Store ou a origem do APK.',
        '3. Relacione o app aos grupos e publique conforme a política.',
      ],
    },
    preview: {
      badge: 'Gestão',
      title: 'Instalação por package e URL',
      subtitle: 'Mostra nome, package, origem da instalação, grupos relacionados e ações de publicação.',
      metrics: ['Nome', 'Package', 'Play URL', 'Dispositivos'],
      columns: ['Busca do app', 'Instalação Play Store', 'Publicação'],
    },
  },
  {
    id: 'dispositivos',
    title: 'Dispositivos',
    path: '/dashboard/dispositivos/-1',
    icon: 'solar:smartphone-2-bold-duotone',
    emoji: '📱',
    accent: '#2563eb',
    description: 'Tela principal para consultar dispositivos, aplicar filtros e abrir ações como histórico, consumo, mapa, reset, reinício, bloqueio e mudança de grupo.',
    purpose: 'É o módulo operacional mais completo para acompanhamento dos equipamentos, reunindo informações técnicas, status, conectividade, bateria, consumo e atalhos de ação remota.',
    usage: 'Utilize quando precisar investigar um equipamento, validar o último log, ver localização no mapa, revisar consumo ou executar ações administrativas diretamente no dispositivo.',
    highlights: ['Busca avançada', 'Mapa', 'Consumo', 'Reset e reinício'],
    featureChips: ['Ver mapa', 'Consumo do aparelho', 'Reset remoto', 'Reiniciar'],
    actionGroups: [
      {
        title: 'Ações do dispositivo',
        icon: 'solar:command-bold-duotone',
        items: [
          'Abra o menu de opções para reiniciar o dispositivo quando for necessário reestabelecer a operação.',
          'Use o reset com cautela em cenários de suporte mais avançado ou recuperação de equipamento.',
          'Em operações com controle mais rígido, valide se a política permite a ação antes de executá-la.',
        ],
      },
      {
        title: 'Análise e acompanhamento',
        icon: 'solar:graph-new-up-bold-duotone',
        items: [
          'Consulte os consumos para entender uso de dados móveis e Wi-Fi por dispositivo.',
          'Verifique o mapa para identificar a última posição registrada e apoiar a equipe de campo.',
          'Use o histórico para reconstruir eventos recentes e entender o comportamento do aparelho.',
        ],
      },
    ],
    visualGuide: {
      title: 'Painel operacional detalhado',
      description: 'O ideal é enxergar esta tela como um centro de comando do dispositivo: dados técnicos, localização, consumo e ações em um único lugar.',
      steps: [
        '1. Busque por Device ID, nome ou IMEI.',
        '2. Abra o modal de detalhes, consumo ou mapa.',
        '3. Execute a ação correta: transferir, reiniciar, resetar ou investigar logs.',
      ],
    },
    preview: {
      badge: 'Operação',
      title: 'Centro de comando do dispositivo',
      subtitle: 'Reúne Device ID, último log, IMEI, bateria, consumo, mapa e atalhos de ação.',
      metrics: ['Device ID', 'Mapa', 'Consumo', 'Ações'],
      columns: ['Filtros e regionais', 'Tabela detalhada', 'Modais operacionais'],
    },
  },
  {
    id: 'transferencias',
    title: 'Transferências',
    path: '/dashboard/transferencias',
    icon: 'solar:transfer-horizontal-bold-duotone',
    emoji: '🔁',
    accent: '#7c3aed',
    description: 'Permite localizar um dispositivo por Device ID e executar fluxos de transferência, incluindo a transferência automática de grupo.',
    purpose: 'Foi criada para concentrar a movimentação de dispositivos entre grupos de forma mais controlada, reduzindo etapas manuais e erros operacionais.',
    usage: 'Abra essa tela quando houver necessidade de reclassificar um equipamento, ajustar o grupo de destino ou executar o fluxo de transferência automática com mais agilidade.',
    highlights: ['Pesquisa por Device ID', 'Transferência automática', 'Exportação da consulta'],
    featureChips: ['Troca de grupo', 'Fluxo automático', 'Consulta rápida'],
    actionGroups: [
      {
        title: 'Transferência de grupo',
        icon: 'solar:repeat-bold-duotone',
        items: [
          'Localize o dispositivo e confirme o grupo atual antes de mover.',
          'Revise a regional e o grupo de destino para evitar troca indevida.',
          'Use a transferência automática para reduzir passos manuais em operações repetitivas.',
        ],
      },
    ],
    preview: {
      badge: 'Fluxo',
      title: 'Transferência de grupo',
      subtitle: 'A tela foi pensada para localizar rapidamente o equipamento e acionar a movimentação correta.',
      metrics: ['Device ID', 'Grupo', 'Regional', 'Status'],
      columns: ['Campo de busca', 'Resultado do dispositivo', 'Ações de transferência'],
    },
  },
  {
    id: 'busca',
    title: 'Buscar',
    path: '/dashboard/busca',
    icon: 'solar:magnifer-bold-duotone',
    emoji: '🔎',
    accent: '#ea580c',
    description: 'Consulta global de dispositivos por Device ID, nome ou IMEI, incluindo itens deletados e acesso rápido às informações do equipamento.',
    purpose: 'Oferece uma pesquisa ampla para localizar rapidamente equipamentos no ambiente, mesmo quando o operador ainda não sabe em qual grupo ou situação o dispositivo está.',
    usage: 'Use quando você tiver apenas um identificador como Device ID, nome ou IMEI e precisar encontrar o dispositivo e abrir seus detalhes com rapidez.',
    highlights: ['Busca por três campos', 'Consulta ampla', 'Modal de detalhes'],
    featureChips: ['Device ID', 'Nome', 'IMEI', 'Mapa rápido'],
    preview: {
      badge: 'Pesquisa',
      title: 'Busca de dispositivos',
      subtitle: 'Inclui filtro de tipo de busca, pesquisa textual, limpeza rápida e exportação para CSV.',
      metrics: ['Device ID', 'Nome', 'IMEI', 'Detalhes'],
      columns: ['Filtro de busca', 'Resultados', 'Exportação'],
    },
  },
  {
    id: 'grupos',
    title: 'Grupos',
    path: '/dashboard/entidades',
    icon: 'solar:devices-bold-duotone',
    emoji: '🗂️',
    accent: '#0f766e',
    description: 'Organiza os grupos do ambiente com filtros por nome, descrição, dispositivo, regional e status.',
    purpose: 'Ajuda a manter a estrutura organizacional dos dispositivos, facilitando o controle por regional, nome do grupo e quantidade de equipamentos associados.',
    usage: 'É a melhor tela para revisar a estrutura dos grupos, localizar rapidamente um cadastro e abrir a lista de dispositivos vinculados a cada agrupamento.',
    highlights: ['Regional', 'Quantidade de dispositivos', 'Acesso à lista de dispositivos'],
    preview: {
      badge: 'Estrutura',
      title: 'Cadastro de grupos',
      subtitle: 'A listagem mostra nome, regional, volume de dispositivos e status, além de atalhos de manutenção.',
      metrics: ['Nome', 'Regional', 'Dispositivos', 'Status'],
      columns: ['Busca e filtros', 'Tabela principal', 'Abrir dispositivos'],
    },
  },
  {
    id: 'politicas',
    title: 'Políticas',
    path: '/dashboard/politicas',
    icon: 'solar:shield-check-bold-duotone',
    emoji: '🛡️',
    accent: '#be123c',
    description: 'Central para criar e editar políticas de MDM aplicadas aos grupos, com controle de aplicativos, bloqueios de funcionalidades, regras de sites e parâmetros de segurança corporativa.',
    purpose: 'Concentra todas as regras de gerenciamento aplicadas nos dispositivos do grupo, permitindo configurar desde instalação de apps até restrições de hardware, acesso à internet e compartilhamento de dados entre perfis.',
    usage: 'Acesse quando precisar criar uma política, adicionar aplicativos obrigatórios, bloquear funcionalidades do aparelho, definir sites permitidos ou restritos, ou ajustar parâmetros de segurança do grupo.',
    highlights: ['Adicionar aplicativos', 'Bloqueios de hardware e software', 'Bloqueio de sites', 'Redes Wi-Fi', 'Controle de perfil cruzado'],
    featureChips: ['FORCE_INSTALLED', 'BLOCKED', 'Sites permitidos', 'Redes Wi-Fi', 'Sem som', 'Copia/Cola', 'Compartilhar dados'],
    actionGroups: [
      {
        title: 'Adicionar aplicativos à política',
        icon: 'solar:download-bold-duotone',
        items: [
          'Na edição da política, acesse a seção de Aplicativos e busque pelo nome ou package name.',
          'Escolha o tipo de instalação: FORCE_INSTALLED instala obrigatoriamente, BLOCKED impede o uso, AVAILABLE deixa o usuário decidir.',
          'O aplicativo será entregue automaticamente aos dispositivos do grupo assim que a política for salva.',
          'Sempre verifique se o package name está correto antes de salvar para evitar erros de instalação.',
        ],
      },
      {
        title: 'Configurar bloqueios de funcionalidades',
        icon: 'solar:lock-bold-duotone',
        items: [
          'Os toggles de bloqueio controlam recursos como Bluetooth, câmera, USB, Wi-Fi, screenshot, modo avião e muito mais.',
          'Para restringir cópia e cola entre o perfil pessoal e de trabalho, use o campo "Copia/Cola Texto".',
          'Para controlar o compartilhamento de documentos e dados via intents (abrir links, mapas, arquivos), use "Compartilhar Documentos".',
          'Bloqueios mais rígidos são recomendados para grupos com dispositivos de uso corporativo exclusivo.',
        ],
      },
      {
        title: 'Bloquear ou liberar sites',
        icon: 'solar:global-bold-duotone',
        items: [
          'Na seção de Bloqueio de Sites, adicione os domínios que devem ser impedidos ou permitidos nos dispositivos.',
          'Defina se a regra é de bloqueio (o site será negado) ou liberação (o site é permitido mesmo em ambientes restritivos).',
          'Cuidado com "Todos": com Bloqueio, ele bloqueia a internet inteira. Para "bloquear tudo, exceto alguns sites", marque Todos como Bloqueio e cadastre as exceções como Liberado.',
          'Salve a política para que as regras de sites sejam enviadas ao navegador dos dispositivos do grupo.',
        ],
      },
      {
        title: 'Enviar redes Wi-Fi',
        icon: 'solar:wi-fi-router-bold-duotone',
        items: [
          'No passo "Redes Wi-Fi", adicione até 10 redes com nome (SSID), segurança e senha.',
          'As redes somam às do aparelho: nenhuma rede cadastrada pelo usuário é apagada.',
          'Tirar uma rede da lista remove só ela. A senha não aparece de volta; campo vazio mantém a atual.',
        ],
      },
      {
        title: 'Controle de perfil cruzado (Android Enterprise)',
        icon: 'solar:shield-user-bold-duotone',
        items: [
          '"Copia/Cola Texto": define se o texto copiado no perfil de trabalho pode ser colado no perfil pessoal e vice-versa.',
          '"Compartilhar Documentos": controla se dados podem ser compartilhados entre perfis via intents como abrir navegador, mapa ou documento.',
          'O padrão de ambos os campos é "Permitido entre perfis". Restrinja conforme a política de segurança da empresa.',
          'Esses campos se aplicam apenas a dispositivos com perfil de trabalho Android Enterprise (BYOD ou corporativo).',
        ],
      },
    ],
    visualGuide: {
      title: 'Camada de segurança operacional',
      description: 'Pense nesta tela como o lugar onde a operação decide o que cada grupo pode fazer, instalar, acessar e compartilhar no dispositivo.',
      steps: [
        '1. Crie ou abra a política do grupo desejado.',
        '2. Adicione os aplicativos obrigatórios e defina o tipo de instalação de cada um.',
        '3. Configure os bloqueios de hardware, software e perfil cruzado conforme a política de segurança.',
        '4. Defina as regras de sites bloqueados ou liberados.',
        '5. Salve e acompanhe a aplicação da política nos dispositivos do grupo.',
      ],
    },
    preview: {
      badge: 'Controle',
      title: 'Regras, bloqueios e aplicativos da operação',
      subtitle: 'A edição da política reúne apps, bloqueios, sites e parâmetros de segurança em um único fluxo.',
      metrics: ['Aplicativos', 'Bloqueios', 'Sites', 'Perfil cruzado'],
      columns: ['Pesquisa', 'Edição da política', 'Salvar e aplicar'],
    },
  },
  {
    id: 'apks',
    title: 'APKS',
    path: '/dashboard/apks',
    icon: 'solar:archive-bold-duotone',
    emoji: '🧩',
    accent: '#0369a1',
    description: 'Gerencia pacotes APK com nome, package name, URL, status e opções de edição.',
    purpose: 'Mantém organizados os pacotes instaláveis utilizados pela operação, servindo como base para consulta, cadastro e atualização de APKs.',
    usage: 'Use essa tela para localizar um pacote por nome ou package name, revisar sua URL e verificar se ele está ativo para uso no sistema.',
    highlights: ['Pacote', 'URL do arquivo', 'Status do APK'],
    preview: {
      badge: 'Distribuição',
      title: 'Repositório de APKs',
      subtitle: 'Ideal para organizar pacotes instaláveis e acompanhar sua disponibilidade no sistema.',
      metrics: ['Nome', 'Pacote', 'URL', 'Status'],
      columns: ['Busca por pacote', 'Lista de arquivos', 'Ações'],
    },
  },
  {
    id: 'regionais',
    title: 'Regionais',
    path: '/dashboard/regionais',
    icon: 'solar:buildings-3-bold-duotone',
    emoji: '🏢',
    accent: '#4f46e5',
    description: 'Tela de cadastro e consulta de regionais com pesquisa por nome ou status e manutenção rápida dos registros.',
    purpose: 'Organiza as unidades regionais que sustentam a estrutura operacional do sistema e que podem ser usadas em filtros e relacionamentos com outros módulos.',
    usage: 'Abra quando precisar revisar regionais existentes, confirmar status cadastral ou editar informações administrativas da estrutura.',
    highlights: ['Nome da regional', 'Status', 'Edição'],
    preview: {
      badge: 'Cadastro',
      title: 'Lista de regionais',
      subtitle: 'Acompanha as regionais disponíveis no ambiente e facilita ajustes administrativos.',
      metrics: ['Nome', 'Status', 'Pesquisa', 'Opções'],
      columns: ['Filtro', 'Tabela', 'Cadastro'],
    },
  },
  {
    id: 'regionais-acessos',
    title: 'Acessos de Regionais',
    path: '/dashboard/regionais/acessos',
    icon: 'solar:shield-keyhole-bold-duotone',
    emoji: '🔐',
    accent: '#7c3aed',
    description: 'Gerencia solicitações de acesso às regionais: conceda acesso a um usuário e aprove ou negue pedidos pendentes.',
    purpose: 'Centraliza o controle de quem acessa cada regional, com solicitações que expiram em 5 dias e notificação dos envolvidos.',
    usage: 'Use para liberar acesso a um usuário específico ou para responder às solicitações pendentes feitas por quem pediu acesso na listagem de regionais.',
    highlights: ['Conceder acesso a um usuário', 'Pendentes com prazo de 5 dias', 'Aprovar ou negar'],
    preview: {
      badge: 'Acesso',
      title: 'Acessos de regionais',
      subtitle: 'Conceda acesso a usuários e gerencie as solicitações pendentes com prazo.',
      metrics: ['Usuário', 'Regional', 'Prazo', 'Ações'],
      columns: ['Conceder', 'Pendentes', 'Aprovação'],
    },
  },
  {
    id: 'usuarios',
    title: 'Usuários',
    path: '/dashboard/users',
    icon: 'solar:users-group-rounded-bold-duotone',
    emoji: '👥',
    accent: '#166534',
    description: 'Controla usuários do sistema com busca por nome, e-mail ou CPF, além de regionais, perfil e situação pendente.',
    purpose: 'É a área de gestão de acesso, onde ficam organizados os usuários da plataforma, seus perfis, vínculos regionais e pendências relacionadas ao uso do sistema.',
    usage: 'Utilize essa tela quando precisar localizar um usuário, revisar permissões, validar regionais vinculadas ou acompanhar situações pendentes de acesso.',
    highlights: ['E-mail', 'Perfil', 'Regionais vinculadas'],
    preview: {
      badge: 'Acesso',
      title: 'Gestão de usuários',
      subtitle: 'A tela ajuda a acompanhar permissões, vínculos regionais e pendências de acesso.',
      metrics: ['Nome', 'E-mail', 'Perfil', 'Pendente'],
      columns: ['Filtros', 'Tabela de usuários', 'Permissões'],
    },
  },
  {
    id: 'chave-acesso',
    title: 'Chave de Acesso',
    path: '/dashboard/chave_acesso',
    icon: 'solar:key-bold-duotone',
    emoji: '🔑',
    accent: '#b45309',
    description: 'Ferramenta para gerar a chave de validação a partir de um código informado pelo operador.',
    purpose: 'Funciona como um utilitário rápido para geração de chave, atendendo cenários operacionais em que o usuário precisa validar ou liberar um processo com agilidade.',
    usage: 'Use quando houver necessidade de informar um código base e obter imediatamente a chave gerada para o próximo passo do atendimento.',
    highlights: ['Entrada manual', 'Geração imediata', 'Uso operacional rápido'],
    preview: {
      badge: 'Utilitário',
      title: 'Gerador de chave',
      subtitle: 'A interface é direta: informar o código, gerar a chave e visualizar o resultado imediatamente.',
      metrics: ['Código', 'Gerar', 'Resultado', 'Validação'],
      columns: ['Entrada', 'Cálculo', 'Retorno'],
    },
  },
  {
    id: 'dispositivos-configurar',
    soMaster: true,
    title: 'Configurar Dispositivos',
    path: '/dashboard/dispositivos/configurar',
    icon: 'solar:settings-bold-duotone',
    emoji: '🛠️',
    accent: '#0d9488',
    description: 'Área para vincular dispositivos, registrar IMEIs em lote e limpar cache de aplicativos.',
    purpose: 'Centraliza ações operacionais rápidas sobre dispositivos sem precisar abrir cada um individualmente.',
    usage: 'Use para vincular um dispositivo por Device ID/IMEI/Serial, registrar vários IMEIs de uma vez ou limpar o cache de um app em um dispositivo.',
    highlights: ['Vincular dispositivo', 'Registrar IMEIs em lote', 'Limpar cache'],
    preview: {
      badge: 'Operação',
      title: 'Configurar dispositivos',
      subtitle: 'Ações rápidas de vínculo, registro e manutenção, com limite de 1 minuto por usuário.',
      metrics: ['Vincular', 'Registrar', 'Limpar cache'],
      columns: ['Vínculo', 'IMEIs', 'Cache'],
    },
  },
  {
    id: 'tickets',
    title: 'Tickets',
    path: '/dashboard/tickets',
    icon: 'solar:chat-round-line-bold-duotone',
    emoji: '🎫',
    accent: '#0ea5e9',
    description: 'Abra tickets de suporte com assunto, categoria e descrição. A categoria define a prioridade e o prazo de atendimento (SLA) em dias úteis, descontando fins de semana e feriados.',
    purpose: 'Canal de atendimento com prazo: cada pedido tem status, histórico e um farol que mostra se o prazo está em dia.',
    usage: 'Use "+ Abrir ticket", escolha a categoria e descreva o problema. Acompanhe pelos cartões: Abertos, Em atendimento, Respondidos (aguardam você), SLA vencido e Resolvidos.',
    highlights: ['Prioridade pela categoria', 'Prazo em dias úteis', 'Histórico completo', 'Cartão de resolvidos'],
    featureChips: ['Abertos', 'Em atendimento', 'Respondidos', 'SLA vencido', 'Resolvidos'],
    preview: {
      badge: 'Suporte',
      title: 'Tickets e SLA',
      subtitle: 'Abra, acompanhe e responda pedidos com prazo de atendimento.',
      metrics: ['Categoria', 'Prioridade', 'Prazo SLA', 'Status'],
      columns: ['Abrir ticket', 'Conversa', 'Histórico'],
    },
  },
  {
    id: 'avisos',
    title: 'Avisos',
    path: '/dashboard/avisos',
    icon: 'solar:bell-bold-duotone',
    emoji: '📣',
    accent: '#f59e0b',
    description: 'Mural de comunicados do sistema: manutenções, mudanças e orientações para todos os usuários.',
    purpose: 'Garante que todo mundo veja o mesmo comunicado, com período de exibição e anexo quando preciso.',
    usage: 'Consulte os avisos em vigor. Os fixados aparecem primeiro; o selo no menu mostra quantos há para ler.',
    highlights: ['Avisos fixados', 'Período de exibição', 'Anexo'],
    preview: {
      badge: 'Comunicação',
      title: 'Mural de avisos',
      subtitle: 'Comunicados com início, fim e anexo.',
      metrics: ['Tipo', 'Início', 'Fim', 'Anexo'],
      columns: ['Em vigor', 'Fixados', 'Anexos'],
    },
  },
  {
    id: 'perfil',
    title: 'Perfil',
    path: '/dashboard/perfil',
    icon: 'solar:user-circle-bold-duotone',
    emoji: '👤',
    accent: '#6366f1',
    description: 'Seus dados de acesso: foto, regionais que você enxerga e troca de senha.',
    purpose: 'Mostra com que perfil e em quais regionais você atua — é isso que define o que aparece nas listas.',
    usage: 'Troque a foto ou a senha. Se faltar uma regional, peça acesso em Regionais.',
    highlights: ['Foto', 'Trocar senha', 'Regionais de acesso'],
    preview: {
      badge: 'Conta',
      title: 'Meu perfil',
      subtitle: 'Foto, senha e regionais.',
      metrics: ['Perfil', 'Regionais', 'Foto', 'Senha'],
      columns: ['Dados', 'Regionais', 'Senha'],
    },
  },
  {
    id: 'logs',
    soMaster: true,
    title: 'Logs do sistema',
    path: '/dashboard/logs',
    icon: 'solar:document-text-bold-duotone',
    emoji: '🧾',
    accent: '#475569',
    description: 'Registros da API, dos webhooks do Google, arquivos de log e o histórico geral de ações (logins, cadastros e comandos).',
    purpose: 'Diagnóstico e auditoria: descobrir o que falhou, quando e quem executou uma ação.',
    usage: 'Use as abas Aplicação, Webhooks do Google, Arquivos .txt e Histórico geral. Filtre por nível (erro, aviso) ou busque por Device ID, IMEI ou mensagem.',
    highlights: ['Erros e avisos da API', 'Webhooks do Google', 'Histórico geral'],
    preview: {
      badge: 'Master',
      title: 'Logs e auditoria',
      subtitle: 'O que aconteceu no sistema, por nível e por origem.',
      metrics: ['Nível', 'Origem', 'Mensagem', 'Quando'],
      columns: ['Aplicação', 'Webhooks', 'Histórico geral'],
    },
  },
  {
    id: 'tickets-categorias',
    soMaster: true,
    title: 'Categorias e SLA',
    path: '/dashboard/tickets/categorias',
    icon: 'solar:list-check-bold-duotone',
    emoji: '🗂️',
    accent: '#0891b2',
    description: 'Cadastro das categorias de ticket, com a prioridade de cada uma e o prazo de atendimento por prioridade.',
    purpose: 'Define, num lugar só, quanto tempo o suporte tem para cada tipo de pedido.',
    usage: 'Crie ou edite a categoria e escolha a prioridade. Ajuste o prazo em dias úteis de cada prioridade direto na tabela.',
    highlights: ['Prioridade da categoria', 'Prazo em dias úteis', 'Confirmação ao apagar'],
    preview: {
      badge: 'Master',
      title: 'Categorias e SLA',
      subtitle: 'Prioridade e prazo de cada tipo de pedido.',
      metrics: ['Categoria', 'Prioridade', 'Prazo'],
      columns: ['Categorias', 'Prazos'],
    },
  },
  {
    id: 'tickets-feriados',
    soMaster: true,
    title: 'Feriados',
    path: '/dashboard/tickets/feriados',
    icon: 'solar:calendar-bold-duotone',
    emoji: '📅',
    accent: '#16a34a',
    description: 'Feriados nacionais, estaduais e municipais que não contam como dia útil no prazo dos tickets.',
    purpose: 'Evita que um feriado consuma o prazo de atendimento.',
    usage: 'Cadastre o feriado com data e âmbito (nacional, estadual ou municipal). Exporte a lista em Excel quando precisar.',
    highlights: ['Nacional, estadual e municipal', 'Exportar Excel', 'Confirmação ao apagar'],
    preview: {
      badge: 'Master',
      title: 'Feriados',
      subtitle: 'Dias que não contam no prazo.',
      metrics: ['Data', 'Âmbito', 'UF', 'Município'],
      columns: ['Feriados', 'Exportar'],
    },
  },
  {
    id: 'monitoramento',
    soMaster: true,
    title: 'Monitoramento',
    path: '/dashboard/monitoramento',
    icon: 'solar:graph-new-bold-duotone',
    emoji: '📈',
    accent: '#dc2626',
    description: 'Mostra a saúde do servidor e do banco de dados, em duas abas.',
    purpose: 'Permite perceber lentidão, falta de memória ou disco cheio antes que o sistema pare.',
    usage: 'Abra a tela quando o sistema estiver lento ou como conferência periódica. Alterne entre as abas Servidor e Banco de dados.',
    highlights: ['CPU, memória e disco', 'Processos do pm2', 'Maiores tabelas', 'Conexões do banco'],
    featureChips: ['Servidor', 'Banco de dados'],
    preview: {
      badge: 'Master',
      title: 'Saúde da infraestrutura',
      subtitle: 'Indicadores do servidor e do banco de dados.',
      metrics: ['CPU', 'Memória', 'Disco', 'Conexões'],
      columns: ['Servidor', 'Banco de dados'],
    },
  },
  {
    id: 'assistente',
    title: 'Assistente',
    path: '/dashboard/app',
    icon: 'solar:chat-round-dots-bold-duotone',
    emoji: '🤖',
    accent: '#7c3aed',
    description: 'Robô flutuante no canto da tela que responde perguntas sobre aparelhos, grupos, políticas, regionais, aplicativos e tickets.',
    purpose: 'Dá a resposta direto, sem navegar por várias telas. É só consulta: não altera nada.',
    usage: 'Clique no robô, digite a pergunta ou apenas o nome de um grupo, aparelho ou regional. O botão "?" lista o que perguntar, por assunto. Esc fecha.',
    highlights: ['Só consulta', 'Gráficos de rosca e linha', 'Busca livre por nome', 'Respeita regionais e perfil'],
    featureChips: ['Resumo do parque', 'Aparelhos online', 'Quem tem o app X', 'Tickets por mês'],
    visualGuide: {
      title: 'Como usar',
      description: 'Do robô à resposta em três passos.',
      steps: [
        'Clique no robô no canto da tela.',
        'Digite a pergunta ou o nome do que procura; use o "?" para ver exemplos.',
        'Leia a resposta (ou o gráfico) e pressione Esc para fechar.',
      ],
    },
    preview: {
      badge: 'Consulta',
      title: 'Pergunte ao GPShub',
      subtitle: 'Respostas rápidas sobre o parque, sem alterar nada.',
      metrics: ['Aparelhos', 'Grupos', 'Políticas', 'Tickets'],
      columns: ['Pergunta', 'Resposta', 'Gráfico'],
    },
  },
  {
    id: 'novidades',
    title: 'Novidades',
    path: '/dashboard/novidades',
    icon: 'solar:bell-bing-bold-duotone',
    emoji: '✨',
    accent: '#1d4ed8',
    description: 'Reúne lançamentos, melhorias e o próprio manual visual das telas para facilitar a comunicação com os usuários.',
    purpose: 'Centraliza o histórico de melhorias do sistema e ajuda a comunicar novidades de forma clara para quem utiliza a plataforma no dia a dia.',
    usage: 'Consulte essa tela sempre que quiser acompanhar versões, entender o que mudou recentemente ou usar o manual como referência rápida para outras áreas.',
    highlights: ['Histórico de versões', 'Manual visual', 'Indicador de novidades'],
    preview: {
      badge: 'Comunicação',
      title: 'Central de novidades',
      subtitle: 'A página registra o que mudou e destaca novas funcionalidades do sistema.',
      metrics: ['Versão', 'Status', 'Data', 'Itens novos'],
      columns: ['Resumo da versão', 'Timeline', 'Manual'],
    },
  },
];

export const NOVIDADES_COUNT = novidadesItems.length;
